import { Inbox } from 'lucide-react';

export default function EmptyState({
    icon: Icon = Inbox,
    title,
    description,
    action
}) {
    return (
        <div className="flex flex-col items-center justify-center py-12 text-center">
            <div className="rounded-full bg-accent-light dark:bg-accent-dark p-6 mb-4">
                <Icon size={48} className="text-muted-light dark:text-muted-dark" />
            </div>
            <h3 className="text-lg font-semibold mb-2">{title}</h3>
            {description && (
                <p className="text-muted-light dark:text-muted-dark max-w-md mb-6">
                    {description}
                </p>
            )}
            {action}
        </div>
    );
}

